import { Pane, Heading, Paragraph, UnorderedList, ListItem, Text, Link } from 'evergreen-ui';

const TermsPage = () => {
  return (
    <Pane maxWidth={900} marginX="auto" padding={32}>

      <Heading size={900} marginBottom={8}>Termini e Condizioni d'Uso</Heading>
      <Paragraph size={300} color="muted" marginBottom={32}>
        Versione 2.0 del 14/04/2026
      </Paragraph>

      <Paragraph size={400} marginBottom={32}>
        I presenti Termini e Condizioni d'Uso (di seguito «Termini») regolano l'accesso e
        l'utilizzo del sito web e dell'applicazione gestionale di <strong>Casa Letizia GAAG</strong>{' '}
        (di seguito «il Servizio»), raggiungibili all'indirizzo{' '}
        <Link href="https://www.casaletizia.net">www.casaletizia.net</Link>. Si invita a leggere
        attentamente i presenti Termini prima di utilizzare il Servizio.
      </Paragraph>

      {/* ------------------------------------------------------------------ */}
      {/* 1. TITOLARE */}
      {/* ------------------------------------------------------------------ */}
      <Heading size={700} marginBottom={8}>1. Titolare e gestore del Servizio</Heading>
      <Paragraph size={400} marginBottom={4}>
        <strong>Casa Letizia GAAG</strong> (Gruppo Appartamento Adolescenti e Giovani)
      </Paragraph>
      <Paragraph size={400} marginBottom={4}>Via Vandalino 25, 10093 Collegno (TO)</Paragraph>
      <Paragraph size={400} marginBottom={32}>
        P.IVA: 13037730010 — E-mail:{' '}
        <Link href="mailto:dvessio7@hotmail.com">dvessio7@hotmail.com</Link>
      </Paragraph>

      {/* ------------------------------------------------------------------ */}
      {/* 2. ACCETTAZIONE */}
      {/* ------------------------------------------------------------------ */}
      <Heading size={700} marginBottom={8}>2. Accettazione dei Termini</Heading>
      <Paragraph size={400} marginBottom={32}>
        L'accesso e l'utilizzo del Servizio implicano la piena accettazione dei presenti Termini.
        Chi non accetta integralmente i presenti Termini è tenuto ad astenersi dall'utilizzo del
        Servizio. L'utilizzo del Servizio da parte di un utente costituisce accettazione dei Termini
        vigenti al momento dell'accesso.
      </Paragraph>

      {/* ------------------------------------------------------------------ */}
      {/* 3. STRUTTURA DEL SERVIZIO */}
      {/* ------------------------------------------------------------------ */}
      <Heading size={700} marginBottom={8}>3. Struttura del Servizio</Heading>
      <Paragraph size={400} marginBottom={12}>Il Servizio si compone di due aree distinte:</Paragraph>
      <UnorderedList marginBottom={12}>
        <ListItem>
          <strong>Sito pubblico</strong> — pagine informative liberamente accessibili
          (presentazione della struttura, servizi, contatti, documenti legali). Non richiede
          registrazione né autenticazione.
        </ListItem>
        <ListItem>
          <strong>Area riservata</strong> — piattaforma gestionale accessibile esclusivamente al
          personale autorizzato (direttore, educatori, operatori) tramite credenziali fornite dalla
          direzione. Consente la gestione degli ospiti, dei turni di lavoro, del diario educativo,
          della documentazione e delle comunicazioni interne.
        </ListItem>
      </UnorderedList>
      <Paragraph size={400} marginBottom={32}>
        L'accesso all'area riservata è consentito solo a soggetti che abbiano ricevuto formale
        autorizzazione dalla direzione di Casa Letizia GAAG. Qualsiasi tentativo di accesso non
        autorizzato costituisce una violazione dei presenti Termini e può configurare un illecito
        civile e/o penale.
      </Paragraph>

      {/* ------------------------------------------------------------------ */}
      {/* 4. CREDENZIALI E SICUREZZA */}
      {/* ------------------------------------------------------------------ */}
      <Heading size={700} marginBottom={8}>4. Credenziali di accesso e sicurezza</Heading>
      <UnorderedList marginBottom={32}>
        <ListItem>
          Le credenziali di accesso all'area riservata (username e password) sono personali e
          non cedibili. L'utente è responsabile della loro custodia e riservatezza.
        </ListItem>
        <ListItem>
          In caso di smarrimento, furto o compromissione delle credenziali, l'utente deve
          notificarlo immediatamente alla direzione per la revoca e il rinnovo.
        </ListItem>
        <ListItem>
          È vietato condividere le credenziali con terzi, anche se appartenenti alla stessa
          organizzazione ma non autorizzati dalla direzione.
        </ListItem>
        <ListItem>
          Casa Letizia GAAG si riserva il diritto di sospendere o revocare l'accesso in
          qualsiasi momento, in caso di violazione dei presenti Termini, di cessazione del
          rapporto di lavoro/collaborazione o per motivi di sicurezza.
        </ListItem>
        <ListItem>
          Le password sono conservate sul server in forma di hash crittografico e non sono
          mai accessibili in chiaro al personale tecnico.
        </ListItem>
      </UnorderedList>

      {/* ------------------------------------------------------------------ */}
      {/* 5. USO CONSENTITO */}
      {/* ------------------------------------------------------------------ */}
      <Heading size={700} marginBottom={8}>5. Uso consentito e obblighi dell'utente</Heading>
      <Paragraph size={400} marginBottom={12}>
        L'utente si impegna a utilizzare il Servizio esclusivamente per le finalità istituzionali
        di Casa Letizia GAAG e nel rispetto della normativa vigente. In particolare è fatto divieto
        di:
      </Paragraph>
      <UnorderedList marginBottom={32}>
        <ListItem>accedere, utilizzare o tentare di accedere a dati di utenti o ospiti senza
          essere stato espressamente autorizzato dalla direzione per quella specifica funzione;</ListItem>
        <ListItem>estrarre, copiare, distribuire o trasmettere a terzi i dati personali di ospiti,
          collaboratori o volontari presenti nel sistema, al di fuori di quanto previsto
          dalle procedure operative interne;</ListItem>
        <ListItem>caricare nel sistema documenti, file o contenuti che non siano pertinenti
          all'attività educativa e gestionale della struttura, o che contengano contenuti
          illeciti, diffamatori, offensivi o che violino i diritti di terzi;</ListItem>
        <ListItem>utilizzare il Servizio per attività di qualsiasi natura che esulino dall'attività
          di Casa Letizia GAAG;</ListItem>
        <ListItem>compromettere la sicurezza, l'integrità o la disponibilità del sistema
          (es. tentativi di accesso non autorizzato, iniezione di codice malevolo, sovraccarico
          del server);</ListItem>
        <ListItem>aggirare i meccanismi di autenticazione, controllo degli accessi o protezione
          dei dati implementati nel sistema.</ListItem>
      </UnorderedList>

      {/* ------------------------------------------------------------------ */}
      {/* 6. DATI SENSIBILI E PRIVACY */}
      {/* ------------------------------------------------------------------ */}
      <Heading size={700} marginBottom={8}>6. Trattamento dei dati personali e obblighi di riservatezza</Heading>
      <Paragraph size={400} marginBottom={12}>
        Il Servizio gestisce dati personali di soggetti vulnerabili, in particolare minori. Ogni
        utente dell'area riservata è tenuto a:
      </Paragraph>
      <UnorderedList marginBottom={12}>
        <ListItem>
          trattare i dati personali presenti nel sistema con la massima riservatezza, rispettando
          scrupolosamente le disposizioni del Regolamento (UE) 2016/679 (GDPR), del D.Lgs.
          196/2003 e delle procedure interne di Casa Letizia GAAG;
        </ListItem>
        <ListItem>
          accedere esclusivamente ai dati necessari per lo svolgimento delle proprie mansioni
          (principio di minimizzazione e need-to-know);
        </ListItem>
        <ListItem>
          segnalare immediatamente alla direzione qualsiasi accesso non autorizzato, perdita,
          sottrazione o divulgazione di dati personali (potenziale data breach);
        </ListItem>
        <ListItem>
          non effettuare copie non autorizzate di documenti o dati personali estratti dal sistema;
        </ListItem>
        <ListItem>
          rispettare i limiti di accesso definiti dal proprio profilo di ruolo (operatore,
          educatore, direttore).
        </ListItem>
      </UnorderedList>
      <Paragraph size={400} marginBottom={32}>
        Il trattamento dei dati effettuato attraverso il Servizio è disciplinato dalle{' '}
        <Link href="/informativa-ospiti">Informativa per gli Ospiti</Link> e dall'
        <Link href="/informativa-collaboratori">Informativa per i Collaboratori</Link>, che si
        intendono parte integrante dei presenti Termini.
      </Paragraph>

      {/* ------------------------------------------------------------------ */}
      {/* 7. CONTENUTI CARICATI */}
      {/* ------------------------------------------------------------------ */}
      <Heading size={700} marginBottom={8}>7. Contenuti caricati dagli utenti</Heading>
      <Paragraph size={400} marginBottom={12}>
        L'utente è responsabile di tutti i contenuti caricati nel sistema (documenti, allegati,
        note, comunicazioni). In particolare:
      </Paragraph>
      <UnorderedList marginBottom={32}>
        <ListItem>
          Non è consentito caricare file con estensioni eseguibili (.exe, .php, .sh, .bat, ecc.)
          o contenuti potenzialmente dannosi.
        </ListItem>
        <ListItem>
          I file caricati devono essere pertinenti all'attività educativa e gestionale della
          struttura (es. documenti in formato PDF, immagini, documenti Word/Excel).
        </ListItem>
        <ListItem>
          Il caricamento di documenti contenenti dati personali di terzi non autorizzati è vietato.
        </ListItem>
        <ListItem>
          Casa Letizia GAAG si riserva il diritto di rimuovere contenuti inappropriati o non
          pertinenti.
        </ListItem>
      </UnorderedList>

      {/* ------------------------------------------------------------------ */}
      {/* 8. PROPRIETÀ INTELLETTUALE */}
      {/* ------------------------------------------------------------------ */}
      <Heading size={700} marginBottom={8}>8. Proprietà intellettuale</Heading>
      <Paragraph size={400} marginBottom={32}>
        Il software, il codice sorgente, il design e i contenuti del Servizio sono di proprietà di
        Casa Letizia GAAG e/o dei rispettivi fornitori tecnici. È vietata la riproduzione,
        distribuzione, modifica o utilizzo non autorizzato di qualsiasi parte del Servizio, salvo
        espressa autorizzazione scritta. I marchi, i loghi e le denominazioni presenti nel sito
        sono protetti dalla normativa vigente.
      </Paragraph>

      {/* ------------------------------------------------------------------ */}
      {/* 9. DISPONIBILITÀ E RESPONSABILITÀ */}
      {/* ------------------------------------------------------------------ */}
      <Heading size={700} marginBottom={8}>9. Disponibilità del Servizio e limitazione di responsabilità</Heading>
      <Paragraph size={400} marginBottom={12}>
        Casa Letizia GAAG si impegna a garantire la disponibilità e il corretto funzionamento del
        Servizio, ma non può garantire:
      </Paragraph>
      <UnorderedList marginBottom={12}>
        <ListItem>la disponibilità ininterrotta del Servizio (possono verificarsi interruzioni per
          manutenzione, aggiornamenti o cause di forza maggiore);</ListItem>
        <ListItem>l'assenza assoluta di errori tecnici o vulnerabilità informatiche;</ListItem>
        <ListItem>la compatibilità con ogni dispositivo o browser.</ListItem>
      </UnorderedList>
      <Paragraph size={400} marginBottom={32}>
        Casa Letizia GAAG non risponde dei danni derivanti dall'uso improprio del Servizio da parte
        degli utenti, né di eventuali perdite di dati causate da comportamenti degli utenti stessi.
        La responsabilità del gestore è limitata nei massimi consentiti dalla legge italiana.
      </Paragraph>

      {/* ------------------------------------------------------------------ */}
      {/* 10. SEGNALAZIONE INCIDENTI */}
      {/* ------------------------------------------------------------------ */}
      <Heading size={700} marginBottom={8}>10. Segnalazione di incidenti di sicurezza</Heading>
      <Paragraph size={400} marginBottom={32}>
        Chiunque rilevi una vulnerabilità di sicurezza, un accesso non autorizzato o una potenziale
        violazione dei dati personali è tenuto a segnalarlo immediatamente alla direzione di Casa
        Letizia GAAG all'indirizzo{' '}
        <Link href="mailto:dvessio7@hotmail.com">dvessio7@hotmail.com</Link>. In caso di data
        breach confermato, Casa Letizia GAAG è tenuta a notificarlo al Garante per la protezione
        dei dati personali entro 72 ore, ai sensi dell'art. 33 del GDPR.
      </Paragraph>

      {/* ------------------------------------------------------------------ */}
      {/* 11. MODIFICHE */}
      {/* ------------------------------------------------------------------ */}
      <Heading size={700} marginBottom={8}>11. Modifiche ai Termini</Heading>
      <Paragraph size={400} marginBottom={32}>
        Casa Letizia GAAG si riserva il diritto di modificare i presenti Termini in qualsiasi
        momento. Le modifiche saranno pubblicate su questa pagina con aggiornamento della data in
        calce. L'utilizzo continuato del Servizio dopo la pubblicazione delle modifiche costituisce
        accettazione dei nuovi Termini. In caso di modifiche sostanziali, gli utenti dell'area
        riservata saranno informati tramite comunicazione interna.
      </Paragraph>

      {/* ------------------------------------------------------------------ */}
      {/* 12. LEGGE APPLICABILE E FORO */}
      {/* ------------------------------------------------------------------ */}
      <Heading size={700} marginBottom={8}>12. Legge applicabile e foro competente</Heading>
      <Paragraph size={400} marginBottom={32}>
        I presenti Termini sono regolati dalla legge italiana. Per qualsiasi controversia relativa
        all'interpretazione, validità o esecuzione dei presenti Termini, è competente in via
        esclusiva il Foro di Torino, salvo diversa disposizione imperativa di legge applicabile ai
        consumatori.
      </Paragraph>

      {/* ------------------------------------------------------------------ */}
      {/* FOOTER */}
      {/* ------------------------------------------------------------------ */}
      <Pane borderTop="muted" paddingTop={16}>
        <Text size={300} color="muted">
          Versione 2.0 — Ultimo aggiornamento: 14 aprile 2026
        </Text>
      </Pane>
      <Pane marginTop={12}>
        <Text size={300} color="muted">
          Il fornitore del sito web non è responsabile della conformità legale dei contenuti di
          questa pagina, che è redatta e aggiornata a cura del Titolare del trattamento.
        </Text>
      </Pane>

    </Pane>
  );
};

export default TermsPage;
